'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');

var _CompanyField = require('../../components/Company/CompanyContactUs/CompanyField/CompanyField');var _CompanyField2 = _interopRequireDefault(_CompanyField);
var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _components = require('../../components');


var _LetterSubscriptionForm = require('./LetterSubscriptionForm.scss');var styles = _interopRequireWildcard(_LetterSubscriptionForm);
var _RealtorLanding = require('../../../static/images/RealtorLanding');var _RealtorLanding2 = _interopRequireDefault(_RealtorLanding);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // styles
var
LetterSubscriptionFormComponent = function (_Component) {_inherits(LetterSubscriptionFormComponent, _Component);
    function LetterSubscriptionFormComponent(props) {_classCallCheck(this, LetterSubscriptionFormComponent);var _this = _possibleConstructorReturn(this,
        _Component.call(this, props));_this.






        submitForm = function (values) {return console.log(values);};_this.

        handleSubmit = function (evt) {
            _this.props.handleSubmit(_this.submitForm)(evt);
            return true;
        };_this.state = { sending: false, params: {} };return _this;}LetterSubscriptionFormComponent.prototype.

    render = function render() {
        var translate = this.props.translate('letterSubscription');

        return (
            _react2.default.createElement('div', { className: styles.wrapper },
                _react2.default.createElement('div', { className: styles.titleWripper },
                    _react2.default.createElement('div', { className: styles.blockImage },
                        _react2.default.createElement('img', { src: _RealtorLanding2.default.newsletter, alt: '' }),
                        _react2.default.createElement('span', null,
                            translate('title'))),


                    _react2.default.createElement('p', null,
                        translate('subtitle')),

                    _react2.default.createElement('p', { className: styles.information },
                        translate('information'))),


                _react2.default.createElement('form', null,
                    _react2.default.createElement('div', { className: styles.inputsWrapper },
                        _react2.default.createElement('div', { className: styles.columnInputs },
                            _react2.default.createElement(_reduxForm.Field, {
                                name: 'name',
                                component: _CompanyField2.default,
                                type: 'text',
                                validate: [_reduxFormValidators.required],
                                placeholder: translate('nameTitle'),
                                translateForError: translate('errorFieldMessages'),
                                isRtl: this.props.isRtl }),

                            _react2.default.createElement(_reduxForm.Field, {
                                name: 'email',
                                component: _CompanyField2.default,
                                type: 'text',
                                placeholder: translate('emailTitle'),
                                translateForError: translate('errorFieldMessages'),
                                isRtl: this.props.isRtl })),


                        _react2.default.createElement('p', null,
                            _react2.default.createElement('img', { src: _RealtorLanding2.default.chekMark, alt: '' }),
                            translate('warning'))),


                    _react2.default.createElement('div', { className: styles.submitBlock },
                        _react2.default.createElement(_components.OMButtonWithPreloader, {
                            showPreloader: this.state.sending,
                            onClick: this.handleSubmit,
                            className: 'contactUsForm',
                            innerText: translate('buttonText') })))));





    };return LetterSubscriptionFormComponent;}(_react.Component);


LetterSubscriptionFormComponent.propTypes = {
    translate: _propTypes2.default.func,
    handleSubmit: _propTypes2.default.func,
    isRtl: _propTypes2.default.bool,
    contactUs: _propTypes2.default.object };exports.default =


LetterSubscriptionFormComponent;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LetterSubscriptionForm/LetterSubscriptionFormComponent.js
// module id = 2671
// module chunks = 0